module.exports = __webpack_public_path__ + "static/media/fuel.202250fc.png";